export const SET_COOKIES = 'SET_COOKIES'
